import JustValidate from 'just-validate'

export default class ContactForm {
  static init() {
    console.debug('== Contact Form component ==')

    const form = document.querySelector('#contact-form')
    const formSubmittButton = form.querySelector('.form-button--submit')

    let postBody = {}

    const inputs = document.querySelectorAll('.form-item')
    const randomCode = generateRandomCode(6)

    // trick in order to avoid autocompletion
    // adding a random code
    inputs.forEach((input) => {
      const originalName = input.getAttribute('name')
      const newName = `${originalName}-${randomCode}`
      input.setAttribute('name', newName)
    })

    // init validation
    const validation = new JustValidate('#contact-form')

    validation
      .addField('#contactName', [
        {
          rule: 'required',
          errorMessage: 'Il campo nome è obbligatorio',
        },
      ])
      .addField('#contactEmail', [
        {
          rule: 'required',
          errorMessage: 'Il campo email è obbligatorio',
        },
        {
          rule: 'email',
          errorMessage: 'Il campo email non è corretto',
        },
      ])
      .addField('#contactMessage', [
        {
          rule: 'required',
          errorMessage: 'Il campo messaggio è obbligatorio',
        },
      ])
      .addField('#contactPrivacy', [
        {
          rule: 'required',
          errorMessage:
            "È necessario leggere e confermare l'informativa della privacy",
        },
      ])
      .onSuccess((event) => {
        // trick in order to avoid autocompletion
        // restoring proper name
        const inputs = form.querySelectorAll('.form-item')
        inputs.forEach((input) => {
          const originalName = input.getAttribute('name')
          const nameWithoutCode = originalName.split('-')[0]
          input.setAttribute('name', nameWithoutCode)
        })

        formSubmittButton.classList.add('h-hide')

        postBody = {
          contactName: form.elements.contactName.value,
          contactEmail: form.elements.contactEmail.value,
          contactMessage: form.elements.contactMessage.value,
        }

        const formFields = document.querySelector('.form-fields')
        const formActions = document.querySelector('.form-actions')

        const formSubmissionMsgOK = document.querySelector(
          '.form-submission-message.success'
        )
        const formSubmissionMsgKO = document.querySelector(
          '.form-submission-message.error'
        )

        const asyncPostCall = async () => {
          // console.log('----> asyncPostCall')

          formSubmissionMsgOK.classList.add('h-hide')
          formSubmissionMsgKO.classList.add('h-hide')

          try {
            const response = await fetch('./sendMail.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(postBody),
            })

            const result = await response.text()

            // console.log('----> result: ', result)

            if (result === 'OK') {
              formFields.classList.add('h-hide')
              formActions.classList.add('h-hide')
              formSubmissionMsgOK.classList.remove('h-hide')
            } else {
              formFields.classList.add('h-hide')
              formActions.classList.add('h-hide')
              formSubmissionMsgKO.classList.remove('h-hide')
            }

            formSubmittButton.classList.remove('h-hide')
          } catch (error) {
            // console.log('----> error', error)
            formSubmissionMsgKO.classList.remove('h-hide')
            formSubmittButton.classList.remove('h-hide')
            console.log(error)
          }
        }

        asyncPostCall()
      })
  }
}

function generateRandomCode(length) {
  const charset =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let code = ''

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length)
    code += charset[randomIndex]
  }

  return code
}
